import baseApi from "./baseApi"

export default  {
    /**
     * Fetch Division from server by ID.
     * @param {int} divisionID 
     * @return {Object} -- Division
     */
    async getDivision(divisionID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/divisions/Division/" + divisionID);
        return result.data;
    },
    /**
     * Add Division data to server by ID.
     * @param {int} divisionID
     * @param {string} kmlFile
     * @return {Object} -- DivisionUploadResponse
     */
    async addDivisionData(divisionID, kmlFile) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/divisions/Division/" + divisionID, kmlFile, { headers: { "Content-Type": "application/xml" } });
        return result.data;
    }
}
